<div *renderInProductResult="LayoutTargets.Actions" add-to-cart [attr.layout]="layout()">
  <ideal-cart-view-purchase-options [productId]="productId()" [layout]="layout()"></ideal-cart-view-purchase-options>
</div>
